export const INACTIVE_VERSION = "INACTIVE_VERSION";
export const getInactiveVersion = (data) => {
    return {
        type: INACTIVE_VERSION,
        payload: data
    }
}